/* SQLMorph Paths */
export const demo = 'demo';
export const translate = 'translate';
export const supportStatements = 'support-statements';
export const api = 'api';
export const settings = 'settings';
export const demoQueries = 'demo-queries';
export const about = 'about';
